import { LatLngExpression, LeafletEvent } from "leaflet";
import React from "react";
import { useMapEvent } from "react-leaflet";

import useContextedFunction from "../../internal/hooks/useContextedFunction";

interface EventHandlerContext extends Props {}

function eventHandler(this: EventHandlerContext, event: LeafletEvent) {
	this.onChangeCenter?.call(null, event.target.getCenter());
}

export interface Props {
	onChangeCenter?: (coordinates: LatLngExpression) => void;
}

export const CenterController: React.FC<Props> = ({ onChangeCenter }) => {
	const [contextedEventHandler, setEventHandlerContext] =
		useContextedFunction(eventHandler, { onChangeCenter });

	setEventHandlerContext({ onChangeCenter });

	useMapEvent("dragend", contextedEventHandler);
	useMapEvent("moveend", contextedEventHandler);

	return <></>;
};
